import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { StreamboxViewModel } from "../../_models/generatedModels";
import { OpentokService } from "../../_services/opentok.service";
import { StreamBoxService } from "../../_services/generatedServices";

@Component({
  selector: 'bxl-caption-box',
  template: `
    <div class="form-row mb-2">
      <div class="col-md-4">
        <label>{{ box.roomName }}</label>
        <select class="form-control" [(ngModel)]="box.selectedDevice">
          <option *ngFor="let device of audioInputs" [value]="device.deviceId">{{ device.label }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="d-block">&nbsp;</label>
        <button *ngIf="!publishing" class="btn btn-admin-primary" type="button" (click)="startCaptionsChannel()">Start Captions</button>
        <button *ngIf="publishing" class="btn btn-danger" type="button" (click)="stopCaptionsChannel()">Stop Captions</button>
      </div>
    </div>
  `,
})
export class CaptionBoxComponent implements OnInit {
  initialized = false;

  @Input() audioInputs: OT.Device[];
  @Input() box: StreamboxViewModel;
  private session: OT.Session;
  publishing: boolean;
  private publisher: OT.Publisher;

  constructor(private opentokService: OpentokService, private streamBoxService: StreamBoxService, private renderer: Renderer2) { }

  stopCaptionsChannel() {
    if (this.publisher) {
      this.session.unpublish(this.publisher);
    }
    this.publishing = false;
    this.streamBoxService.stopCaptions(this.box.id).subscribe();
  }

  startCaptionsChannel() {
    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');
    this.publisher = OT.initPublisher(el, {
      publishAudio: true,
      audioSource: this.box.selectedDevice,
      publishVideo: false,
      publishCaptions: true
    });

    this.session.publish(this.publisher, (err) => {
      if (err) {
        alert(err.message);
      } else {
        this.publishing = true;
        this.streamBoxService.startCaptions(this.box.id).subscribe();
        console.log('Publisher started');
      }
    });
  }

  ngOnInit(): void {
    this.InitOpenTok();
    this.initialized = true;
  }

  private InitOpenTok() {
    this.opentokService
      .initsessionForStreamBoxCaptions(this.box.id)
      .then((session: OT.Session) => {
        this.session = session;
        // this.session.on('streamCreated', (event) => {
        //   console.log(event.stream.name);
        //   console.log(event.stream.connection.data);
        //
        //   let subscription = this.session.subscribe(event.stream, 'videoCanvas', {
        //     insertMode: 'append',
        //     subscribeToAudio: false,
        //     subscribeToVideo: false,
        //     preferredResolution: {
        //       width: 1280,
        //       height: 720
        //     },
        //     style: {nameDisplayMode: 'off'},
        //   });
        //   //subscription.element.hidden = true;
        //
        //   // subscription.subscribeToCaptions(true);
        //   // subscription.on('captionReceived', function (event) {
        //   //   console.log(`Caption received for stream ${event.streamId}`);
        //   //   console.log(`Caption text: ${event.caption}`);
        //   //   console.log(`Final text: ${event.isFinal}`);
        //   // })
        // });

      }).then(() => this.opentokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }
}
